export const MuiTablePagination = {
    defaultProps: {
        nextIconButtonProps: {
            size: 'small'
        },
        backIconButtonProps: {
            size: 'small'
        }
    },
    styleOverrides: {
        root: ({ theme })=>({
                backgroundColor: theme.palette.background.default
            }),
        toolbar: {
            // This is approximately the height of the other size=small header row
            minHeight: 36
        },
        select: ({ theme })=>({
                ...theme.typography.body2
            })
    }
};

//# sourceMappingURL=table-pagination.js.map